export default {
  callingAPI: false,
  access_token: null,
  organisationid: '',
  orgRemarks: '',
  isEnglishDateEnabled: false,
  enable2FA: '',
  modules: '',
  endDate: '',
  transactionDate: '',
  expiry: '',
  fyId: '',
  startDate: '',
  nepaliNewDate: '',
  fyName: '',
  taxType: '',
  ablePrintRealTime: false,
  warehouseData: {
  },
  counterData: {
  },
  user: {
  },
  organisationName: '',
  organisationIRDActive: false,
  irdUsername: '',
  irdPassword: '',
  organisationAddress: '',
  organisationContact: '',
  organisationLogo: '',
  organisationPanVatNo: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js